import React from 'react';


export default class EditableSpan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            focused: false,
            value: this.props.textValue
        };
    }

    componentDidUpdate(prevProps) {

        if (this.state.focused)
            this.nameInput.focus();  //make cursor active on new element

        // Fix: update value if textValue prop changes
        if (prevProps.textValue !== this.props.textValue && !this.state.focused) {
            this.setState({ value: this.props.textValue });
        }
    }

    render() {

        let { value, focused } = this.state;
        let { item, fieldName, langCode = "", updateHandler, editable = true } = this.props; // textValue, isEditable = "true"

        let completeFieldName = fieldName + langCode;

        let fieldStyle = { width: "100%", marginLeft: "10px" };
        let rtlStyle = { direction: "rtl", textAlign: "right" };
        let emptyStyle = { color: "gray" };

        if (langCode === "he")
            fieldStyle = { ...fieldStyle, ...rtlStyle };
        if (!value)
            fieldStyle = { ...fieldStyle, ...emptyStyle };

        if (!focused)
            return (<span
                onClick={() => { if (editable) this.setState({ focused: true }) }}
                style={fieldStyle} >{value ? value : "empty"}</span>)  //default render as span
        else
            return (
                //render as input field
                <form style={fieldStyle} onSubmit={e => e.preventDefault()}>
                    <input type="text"

                        onChange={(e) => {
                            let val = e.target.value;

                            this.setState({ value: val });

                            updateHandler(item, completeFieldName, val);
                            updateHandler(item, 'updated', 1); //wtf? todo: do not use additional field, use item.updated event instead
                        }} onKeyDown={(e) => {
                            if (e.key === ' ' || e.key === 'Spacebar' || e.key.startsWith('Arrow')) {
                                e.stopPropagation();
                            }
                            if (e.key === 'Enter' || e.key === 'Escape') {
                                e.preventDefault();
                                this.setState({ focused: false });
                            }
                        }}

                        onBlur={() => { this.setState({ focused: false }) }}
                        ref={(input) => { this.nameInput = input; }}

                        style={fieldStyle}
                        value={value ? value : ""} //show only local state value
                    />
                </form>)
    }
}